module.exports = __webpack_public_path__ + "static/media/pagination-last-disabled.b23b5222.svg";